// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--M6drS";
export var borderRadius = "index-module--border-radius--iB8yg";
export var clearButtonStyles = "index-module--clear-button-styles--TyV12";
export var left = "index-module--left--PEgyE";
export var right = "index-module--right--PT+t9";
export var right_on_desktops = "index-module--right_on_desktops--uTtrW";
export var time_heading = "index-module--time_heading--QITQR";
export var time_slots = "index-module--time_slots--vSv7Z";
export var titleFont = "index-module--title-font--UiPaL";